import { useNavigate } from 'react-router-dom'
import { Typography, Button } from '@mui/material'
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined'

const TableLinkButton = ({ label = 'Рассылка', href = '#' }) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (!href) return
    navigate(href)
  }
  return (
    <Button
      onClick={handleClick}
      size="small"
      endIcon={<ArrowCircleRightOutlinedIcon />}
    >
      <Typography variant="buttonSm">{label}</Typography>
    </Button>
  )
}

export default TableLinkButton
